import { EntityTypes } from "../../EntityTypes";
import { IHydraResource } from "../../types";

export enum StatisticAction {
    // Briefs activities
    BRIEF_CREATED = "brief_created",
    BRIEF_ASSIGNED = "brief_assigned",

    // Individuals activities
    INDIVIDUAL_SPACE = "individual_space",
    INDIVIDUAL_WORK = "individual_work",
    INDIVIDUAL_CORRECTION = "individual_correction",
    INDIVIDUAL_MESSAGE = "individual_message",

    // Groups activities
    GROUP_SPACE = "group_space",
    GROUP_WORK = "group_work",
    GROUP_CORRECTION = "group_correction",
    GROUP_MESSAGE = "group_message",
    GROUP_TASK = "group_task",

    // Learners validations
    VALIDATION_VALIDATED = "validation_validated",
    VALIDATION_UNVALIDATED = "validation_unvalidated",

    // Professional situations
    PROFESSIONAL_SITUATION_CREATED = "professional_situation_created",

    // Works activities
    WORK_CORRECTED = "work_corrected",
    WORK_NON_CORRECTED = "work_non_corrected",
}

interface IStatisticClassroom extends IHydraResource {
    title: string;
    externalReferences: string[];
}

export interface IStatisticResource extends IHydraResource {
    "@type": EntityTypes.STATISTIC;
    day: string;
    classroom: IStatisticClassroom | null;
    action: StatisticAction;
    number: number;
}

export function isStatisticResource(resource: IHydraResource): resource is IStatisticResource {
    return resource["@type"] === EntityTypes.STATISTIC;
}
